import { Route, UrlMatchResult, UrlSegment } from '@angular/router';
import {
  PageChangelogComponent,
  PageLoginComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';

import { authorizationGuardFn } from '@infodata-group/inf-commons';
import { urgencyGuard } from './model/guard/urgency.guard';

function ticketMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments.length === 0 || segments[0].path !== 'ticket') {
    return null;
  }

  switch (segments.length) {
    case 1:
      return { consumed: segments };
    case 2:
      return {
        consumed: segments,
        posParams: { preselectionToDisplay: segments[1] },
      };
    case 3:
      if (segments[2].path === 'settings') {
        return {
          consumed: segments,
          posParams: { preselectionToEdit: segments[1] },
        };
      }
      return null;
    default:
      return null;
  }
}

export const appRoutes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  {
    path: '',
    loadComponent: () =>
      import('./page/page-main/page-main.component').then(
        (m) => m.PageMainComponent,
      ),
    canActivate: [authorizationGuardFn, urgencyGuard],
    children: [
      {
        matcher: ticketMatcher,
        loadComponent: () =>
          import('./page/page-sav/page-sav.component').then(
            (m) => m.PageSavComponent,
          ),
      },
      {
        path: 'settings/:menu',
        loadComponent: () =>
          import('./page/page-settings/page-settings.component').then(
            (m) => m.PageSettingsComponent,
          ),
      },
      {
        path: 'client',
        loadComponent: () =>
          import('./page/page-client/page-client.component').then(
            (m) => m.PageClientComponent,
          ),
      },
      { path: '', redirectTo: 'ticket', pathMatch: 'full' },
      { path: 'changelogs', component: PageChangelogComponent },
    ],
  },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'reset-password', component: PagePwdResetComponent },
  { path: 'ticket', redirectTo: '', pathMatch: 'full' },
  { path: 'sav', redirectTo: '', pathMatch: 'full' },
];
